module.exports = __webpack_public_path__ + "static/front-view-woman-with-sunglasses-b9ddd37fd8fe8a35a981cded6b9a74f5.jpg";